"use client";

import React from "react";
import { ZoomIn } from "lucide-react";
import { Dialog, DialogContent, DialogTrigger, DialogTitle } from "@/components/ui/dialog";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryImages = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687484/img/city_pet_care_golden_retriever_smile.png",
  alt: "Smiling Golden Retriever after its exam",
  className: "col-span-2 row-span-2"
}, {
  id: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687484/img/city_pet_care_kitten_playful.png",
  alt: "Playful kitten in our calming waiting room",
  className: "col-span-1 row-span-1"
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687484/img/city_pet_care_french_bulldog_checkup.png",
  alt: "Calm French Bulldog during its visit",
  className: "col-span-1 row-span-2"
}, {
  id: 4,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687484/img/city_pet_care_rabbit_wellness.png",
  alt: "Domestic rabbit receiving attentive care",
  className: "col-span-1 row-span-1"
}, {
  id: 5,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687484/img/city_pet_care_modern_clinic_interior.png",
  alt: "Modern and serene interior of City Pet Care",
  className: "col-span-2 row-span-1"
}, {
  id: 6,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687484/img/city_pet_care_happy_poodle.png",
  alt: "Joyful poodle after grooming",
  className: "col-span-1 row-span-1"
}];
export default function OurHappyPatients() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  return <section data-section-id="223034" id="our-happy-patients" className="py-20 md:py-32 bg-background text-foreground overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-12 md:mb-20 transition-all duration-700 ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-5xl font-bold mb-6 text-foreground tracking-tight">
            Our Happy Patients
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl font-default leading-relaxed">
            Discover the happy faces of City Pet Care. Each animal is treated with the utmost serenity in our urban oasis dedicated to their well-being.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 auto-rows-[150px] md:auto-rows-[250px] grid-flow-dense">
          {galleryImages.map((img, i) => <GalleryItem key={img.id} img={img} index={i} />)}
        </div>
      </div>
    </section>;
}
function GalleryItem({
  img,
  index
}: {
  img: (typeof galleryImages)[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <Dialog>
      <DialogTrigger asChild data-index={index}>
        <div ref={ref} className={`relative overflow-hidden rounded-3xl cursor-pointer group ${img.className} transition-all duration-700 shadow-md hover:shadow-xl ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`} style={{
        transitionDelay: `${index * 100}ms`
      }}>
          <img src={img.src} alt={img.alt} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105" loading="lazy" />
          <div className="absolute inset-0 bg-primary/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center backdrop-blur-[2px]">
            <ZoomIn className="text-white size-10 drop-shadow-lg" />
          </div>
        </div>
      </DialogTrigger>
      <DialogContent className="max-w-5xl w-[95vw] p-1 md:p-2 bg-background/95 backdrop-blur-md border-border shadow-2xl rounded-3xl">
        <DialogTitle className="sr-only">{img.alt}</DialogTitle>
        <div className="relative w-full h-full max-h-[85vh] rounded-2xl overflow-hidden bg-muted flex items-center justify-center">
          <img src={img.src} alt={img.alt} className="w-full h-full max-h-[85vh] object-contain" />
        </div>
      </DialogContent>
    </Dialog>;
}